var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 7.5C11.667 7.5 4.55033 12.6833 1.66699 20C4.55033 27.3167 11.667 32.5 20.0003 32.5C28.3337 32.5 35.4503 27.3167 38.3337 20C35.4503 12.6833 28.3337 7.5 20.0003 7.5ZM20.0003 28.3333C15.4003 28.3333 11.667 24.6 11.667 20C11.667 15.4 15.4003 11.6667 20.0003 11.6667C24.6003 11.6667 28.3337 15.4 28.3337 20C28.3337 24.6 24.6003 28.3333 20.0003 28.3333ZM20.0003 15C17.2337 15 15.0003 17.2333 15.0003 20C15.0003 22.7667 17.2337 25 20.0003 25C22.767 25 25.0003 22.7667 25.0003 20C25.0003 17.2333 22.767 15 20.0003 15Z",
    fill: "#4C8A7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9f222bd9c035cf2c8e85c411b5086775.svg";
export { ForwardRef as ReactComponent };